import { render, staticRenderFns } from "./RoundConfigForm.vue?vue&type=template&id=5b8a4204"
import script from "./RoundConfigForm.vue?vue&type=script&lang=js"
export * from "./RoundConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports